<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Preparation Expression of Interest</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-blue me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)" >
          <button (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
            class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>
  <!-- <div class="d-flex justify-content-end mb-3 mt-4 mx-3">
    <p-button
      label="Fetch Data from Masters"
      icon="pi pi-save"
      [outlined]="true"
      (click)="fetchMasterData()"
      
    ></p-button>
  </div> -->
  <hr class="my-3" />

  <form [formGroup]="eoiForm" class="container-fluid">
    <!-- Section 1: Expression of Interest -->
    <div class="card shadow-sm mb-4">
      <div class="card-header bg-light d-flex justify-content-between align-items-center">
        <!-- <h5 class="mb-0">Expression of Interest (EoI)</h5> -->
        <!-- <span *ngIf="isEditorDisabled" class="badge bg-secondary">Read Only</span> -->
      </div>
      <div class="card-body">
        <div class="form-group">
          <label class="form-label">
            Expression of Interest (EoI) <b class="text-danger">*</b>
          </label>
          <editor *ngIf="showEditor" [init]="init" formControlName="eoi" 
            class="w-100 border rounded"></editor>
        </div>
      </div>
    </div>

    <!-- Section 2: Annexure -->
    <!-- <div class="text-end mb-4">
      <h6 class="fw-bold mb-1">Annexure I to Appendix E</h6>
      <p class="text-muted fst-italic mb-0">
        (Refers to Para 9(a) of Appendix E)
      </p>
    </div> -->

    <!-- Section 3: Information Proforma -->
    <div class="card shadow-sm mb-4">
      <!-- <div class="card-header bg-light">
        <h5 class="mb-0">Information Proforma</h5>
        <small class="text-muted">An Illustrative List of Elements</small>
      </div> -->
      <div class="card-body">
        <div class="form-group">
          <label class="form-label">
            <!-- Additional Expression of Interest (EoI) <b class="text-danger">*</b> -->
             PDD <b class="text-danger">*</b>
          </label>
          <editor [init]="init" formControlName="comment_2"  class="w-100 border rounded">
          </editor>
        </div>
      </div>
    </div>
  </form>

  <!-- Document Upload Section -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-light">
          <h5 class="mb-0">Document Uploads</h5>
        </div>
        <div class="card-body">
          <app-upload-document [title]="(stepDetails?.name || 'EOI') + ' Document'"
            [isEditable]="stepDetails?.can_edit">
          </app-upload-document>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="d-flex align-items-end flex-column">
    <h5>Annexure II to Appendix E</h5>
    <h6>(Refers to Para 9(b) of Appendix E)</h6>
  </div> -->
  <!-- <div class="d-flex justify-content-between my-4">
    <h5>
      DOCUMENTS/INFORMATION TO BE SUBMITTED AS PART OF RESPONSES TO EoI : AN
      ILLUSTRATIVE LIST
    </h5>
    <p-buttont
      label="Row"
      size="small"
      [outlined]="true"
      (onClick)="addRow()"
      icon="pi pi-plus"
      *ngIf="stepDetails?.can_edit"
    ></p-buttont>
  </div> -->
  <hr />

  <!-- <table class="custom-table">
    <thead>
      <tr>
        <th width="10%">Sr. No</th>
        <th width="80%">Name</th>
        <th
          width="10%"
          *ngIf="stepDetails?.can_edit"
        >
          Action
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of reqDoc; let i = index">
        <td>{{ i + 1 }}</td>

        <td *ngIf="product.edit">
          <textarea
            [(ngModel)]="product.name"
            rows="3"
            wrap="soft"
            class="text-area"
            style="width: 100%; resize: vertical; margin-top: 3px"
          >
          </textarea>
        </td>
        <td *ngIf="!product.edit">
          <span>{{ product.name }}</span>
        </td>

        <td *ngIf="stepDetails?.can_edit">
          <button
            *ngIf="product.edit"
            class="c-btn"
            (click)="product.edit = false"
          >
            Save
          </button>
          <button
            *ngIf="!product.edit"
            class="c-btn"
            (click)="product.edit = true"
          >
            Edit
          </button>
        </td>
      </tr>
    </tbody>
  </table> -->
</div>

<!-- <div class="card">
    <div class="flex justify-content-between align-items-center mb-4">
        <div>
            <h1 class="text-3xl font-bold mb-2">Vendor Compliance Matrix</h1>
            <p class="text-gray-600">Track and manage vendor compliance documentation</p>
        </div>
    </div>

    <p-toast></p-toast>

    <div class="overflow-x-auto">
        <table class="min-w-full bg-white border-collapse">
            
            <thead>
                <tr class="bg-gray-100">
                    <th class="border p-3 text-left min-w-[50px]">Sr</th>
                    <th class="border p-3 text-left min-w-[300px]">Criteria</th>
                    <th *ngFor="let vendor of vendors" class="border p-3 text-center min-w-[200px]">
                        {{vendor}}
                        <div class="text-xs font-normal">Compliance (Yes/No)</div>
                    </th>
                </tr>
            </thead>

            
            <tbody>
                <tr *ngFor="let row of complianceData" [ngClass]="{'bg-gray-50': row.id % 2 === 0}">
                    <td class="border p-3 text-center">{{row.id}}</td>
                    <td class="border p-3">{{row.criteria}}</td>
                    <td *ngFor="let vendor of vendors" class="border p-3">
                        <div class="flex flex-col items-center gap-2">
                            
                            <div class="flex gap-3">
                                <div class="flex items-center">
                                    <p-radioButton 
                                        [name]="'compliance_' + row.id + '_' + vendor"
                                        [value]="'Yes'"
                                        [(ngModel)]="row.vendors[vendor].compliance"
                                        (ngModelChange)="onComplianceChange(row.id, vendor, $event)">
                                    </p-radioButton>
                                    <label class="ml-1">Yes</label>
                                </div>
                                <div class="flex items-center">
                                    <p-radioButton 
                                        [name]="'compliance_' + row.id + '_' + vendor"
                                        [value]="'No'"
                                        [(ngModel)]="row.vendors[vendor].compliance"
                                        (ngModelChange)="onComplianceChange(row.id, vendor, $event)">
                                    </p-radioButton>
                                    <label class="ml-1">No</label>
                                </div>
                            </div>

                            
                            <div *ngIf="row.vendors[vendor].compliance === 'Yes'" class="w-full">
                                <p-fileUpload 
                                    mode="basic" 
                                    chooseLabel="Upload"
                                    [auto]="true"
                                    [maxFileSize]="1000000"
                                    (onSelect)="onFileSelect($event, row.id, vendor)"
                                    styleClass="p-button-sm p-button-outlined"
                                    [showCancelButton]="false"
                                    accept="application/pdf,image/*">
                                </p-fileUpload>
                                <small *ngIf="row.vendors[vendor].file" class="text-green-600 block mt-1">
                                    {{row.vendors[vendor].file.name}}
                                </small>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    
    <div class="flex justify-end mt-4">
        <p-button 
            label="Submit Compliance" 
            icon="pi pi-check" 
            (onClick)="submitCompliance()"
            styleClass="p-button-success">
        </p-button>
    </div>
</div> -->